<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="col-6">
                <h4 class="card-title">Segment Listesi</h4>
              </div>
              <div style="text-align: right;" class="col-6 card-title">
                <button type="submit" class="btn btn-info btn-fill float-right">
                  <a style="color:#fff" href="/#/admin/segment">Yeni Segment</a>
                </button>
              </div>
              <!--<p class="card-category">Here is a subtitle for this table</p>-->
            </template>
            <l-table class="table-hover table-striped"
                     :columns="table1.columns"
                     :data="table1.data">
            </l-table>
          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  const tableColumns = ['Id', 'Segment Adi', 'Ust Segment', 'Aksiyon']
  const tableData = [
    {
      id: 1,
      'segment adi': 'Türkiye',
      'ust segment': '-',
      aksiyon: 'Düzenle - Sil'
    },
    {
      id: 2,
      'segment adi': 'İstanbul',
      'ust segment': 'Türkiye',
      aksiyon: 'Düzenle - Sil'
    },
    {
      id: 3,
      'segment adi': 'Şişli',
      'ust segment': 'İstanbul',
      aksiyon: 'Düzenle - Sil'
    },
    {
      id: 4,
      'segment adi': 'Sıracevizler Caddesi',
      'ust segment': 'Şişli',
      aksiyon: 'Düzenle - Sil'
    },
    {
      id: 5,
      'segment adi': 'Berlin',
      'ust segment': '-',
      aksiyon: 'Düzenle - Sil'
    }
    
  ]
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        table1: {
          columns: [...tableColumns],
          data: [...tableData]
        },
      }
    }
  }
</script>
<style>
</style>
